import { useRouter } from "next/router";
import { PublicSettings } from "@/src/config/PublicSettings";
import { Utils } from "@/src/Utils";

export const useCanonicalURL = () => {
    const router = useRouter();
    return Utils.getCurrentCanonicalURL(router, PublicSettings.CANONICAL_URL_ROOT);
};
